var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({},'v-btn',_vm.attributes,false),_vm.$listeners),[(_vm.$scopedSlots.iconLeft)?_c('span',{staticClass:"mr-2"},[_vm._t("iconLeft")],2):_vm._e(),_c('span',{class:_vm.textClasses},[_vm._t("default")],2),(_vm.$scopedSlots.iconRight)?_c('span',{staticClass:"ml-2"},[_vm._t("iconRight")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }